<template>
    <v-app-bar v-if="$route.name !== 'login'" :height="isScrolled ? height-8 : height" fixed class="navbar navbarbg" app light flat :class="{scrolled: isScrolled, welcome: $route.name === 'welcome'}">
        <v-container class="d-flex px-1 py-0 fill-height align-center flex-row-reverse">
            <div class="d-flex align-center">
                <template v-if="isAuthed">
                    <notifications-menu />
                    <user-nav :name="user.name" :avatar="user.avatar" />
                </template>
                <div v-else-if="pcOnly">
                    <!-- <avatar :to="{name: 'login'}" :size="30" :icon-size="25"/> -->

                    <v-btn :to="{name: 'login'}" color="primary darken-1" depressed :text="$route.name !== 'login'">تسجيل الدخول</v-btn>
                    <!-- <v-btn :to="{name: 'register'}" color="primary darken-1" depressed :outlined="$route.name !== 'register'" class="ms-3">حساب جديد</v-btn> -->
                </div>
            </div>
            
            <v-spacer />
            <div class="d-flex align-center">
                <v-btn v-if="phoneOnly" large icon @click.prevent="$emit('menu')" class="me-1" style="margin-right: -10px">
                    <v-icon size="24">mdi-menu</v-icon>
                </v-btn>
                
                <div class="d-flex align-center justify-center">
                    <logo :width="110" />
                </div>
            </div>
        </v-container>
        <v-progress-linear v-if="linearLoading" :active="linearLoading" :indeterminate="linearLoading" absolute bottom color="secondary" height="2"></v-progress-linear>

    </v-app-bar>
    <v-app-bar v-else :height="isScrolled ? height-8 : height" fixed class="appbg" app light flat></v-app-bar>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import NotificationsMenu from './notifications-menu'

// import Avatar from '../../default/avatar'
import UserNav from './user-nav'

export default {
    props: {
        height: {
            default: 60,
            type: Number
        }
    },
    data(){
        return {
            isScrolled: false,
        }
    },
    components: {
        NotificationsMenu,
        UserNav,
        // Avatar,
    },
    computed: {
        linearLoading(){
            return this.$store.state.globalModule.linearLoading;  
        },
        ...GlobalComputed
    },
    methods: {
        handleScroll(event){
            if (window.scrollY === 0){
                this.isScrolled = false;
            }else if (!this.isScrolled){
                this.isScrolled = true;
            }
        },
        ...GlobalMethods
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss" scoped>
    .navbar{
        background-color: #fff!important;
        transition: all 0.2s ease!important;
        
        &.scrolled, &:not(.welcome){
            // box-shadow: 0 1px 4px 0 rgba(0,0,0, .1)!important;
            border-bottom: 1px solid rgba(#000, 0.1)!important;
        }
    }
</style>